import React, { useState } from "react";
import prmLogoImage from "_assets/images/prm-logo/blue-icon.png";
import { Colors } from "_styles";
import { useSelector, useDispatch } from "react-redux";
import {
  selectAllTimelineAreas,
  selectSelectedTimeline,
  setSelectedTimeline,
} from "_redux/slices/timeline/timeline-areas";
import Modal from "react-bootstrap/Modal";
import { MdCheck } from "react-icons/md";

const LocationTitle = () => {
  const dispatch = useDispatch();
  const selectedTimeline = useSelector(selectSelectedTimeline);
  const timelineAreas = useSelector(selectAllTimelineAreas);
  const [show, setShow] = useState(false);

  const handleSelect = (area) => {
    dispatch(setSelectedTimeline(area));
    setShow(false);
  };

  const zones = Array.isArray(timelineAreas) ? timelineAreas : [];

  return (
    <>
      <div
        //onClick={() => setShow(true)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          backgroundColor: "#f0f6ff",
          border: `1.5px solid ${Colors.PRM_LIGHT_BLUE}`,
          borderRadius: 20,
          padding: "5px 12px 5px 7px",
          marginTop: 2,
          cursor: "pointer",
          userSelect: "none",
          transition: "background-color 0.15s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#daeaff")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f0f6ff")}
      >
        <img
          src={prmLogoImage}
          alt="PRM"
          style={{ height: 22, width: "auto", display: "block" }}
        />
        <span style={{
          fontSize: 14,
          color: Colors.PRM_LIGHT_BLUE,
          fontWeight: "700",
          whiteSpace: "nowrap",
        }}>
          {selectedTimeline?.title ?? "All Airport View"}
        </span>
      </div>

      <Modal show={show} onHide={() => setShow(false)} centered size="sm">
        <Modal.Header
          closeButton
          style={{
            borderBottom: `2px solid ${Colors.PRM_LIGHT_BLUE}`,
            paddingBottom: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <img src={prmLogoImage} alt="PRM" style={{ height: 24, width: "auto" }} />
            <span style={{ fontWeight: "700", fontSize: 15, color: Colors.PRM_LIGHT_BLUE }}>
              Select Zone
            </span>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: "8px 0" }}>
          {/* All Airport View option */}
          <ZoneRow
            label="All Airport View"
            isSelected={!selectedTimeline}
            onClick={() => handleSelect(null)}
          />

          {zones.map((area) => (
            <ZoneRow
              key={area._id ?? area.title}
              label={area.title}
              badge={
                area.arrivals && area.departures ? "ARR + DEP"
                  : area.arrivals ? "ARR"
                    : area.departures ? "DEP"
                      : null
              }
              isSelected={selectedTimeline?._id === area._id}
              onClick={() => handleSelect(area)}
            />
          ))}
        </Modal.Body>
      </Modal>
    </>
  );
};

const ZoneRow = ({ label, badge, isSelected, onClick }) => (
  <div
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 16px",
      cursor: "pointer",
      backgroundColor: isSelected ? "#f0f6ff" : "transparent",
      borderLeft: isSelected ? `3px solid ${Colors.PRM_LIGHT_BLUE}` : "3px solid transparent",
      transition: "background-color 0.1s",
    }}
    onMouseEnter={(e) => !isSelected && (e.currentTarget.style.backgroundColor = "#f8faff")}
    onMouseLeave={(e) => !isSelected && (e.currentTarget.style.backgroundColor = "transparent")}
  >
    <span style={{
      fontSize: 14,
      fontWeight: isSelected ? "700" : "500",
      color: isSelected ? Colors.PRM_LIGHT_BLUE : "#333",
    }}>
      {label}
    </span>
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      {badge && (
        <span style={{
          fontSize: 10,
          fontWeight: "600",
          color: Colors.PRM_LIGHT_BLUE,
          backgroundColor: "#e0eeff",
          borderRadius: 10,
          padding: "2px 7px",
        }}>
          {badge}
        </span>
      )}
      {isSelected && <MdCheck size={16} color={Colors.PRM_LIGHT_BLUE} />}
    </div>
  </div>
);

export default LocationTitle;
